import { useLocation, useNavigate } from "react-router";
import * as ROUTES from "../../../../constants/routes";
import { twMerge } from "tailwind-merge";
import { useFeatureFlagStore } from "../../../../hooks/useFeatureFlags";

export const FinanceNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isSupplierImportsFinanceSectionFeatureFlagEnabled =
    useFeatureFlagStore().isActive("SELLAR_IMPORTS_FINANCE_SECTION");

  const tabs = [
    {
      label: "Sellar credit",
      route: ROUTES.BUSINESS_FINANCE_CREDIT,
    },
    {
      label: "Invoices",
      route: ROUTES.BUSINESS_FINANCE_INVOICES,
    },
    {
      label: "Opening order fees",
      route: ROUTES.BUSINESS_FINANCE_OOF,
    },
    ...(isSupplierImportsFinanceSectionFeatureFlagEnabled
      ? [
          {
            label: "Sellar import ",
            route: ROUTES.BUSINESS_FINANCE_SELLAR_IMPORTS,
          },
        ]
      : []),
  ];

  return (
    <div className="flex w-full max-w-lg items-center border-b border-zinc-300">
      {tabs.map((tab, idx) => (
        <div
          key={idx}
          onClick={() => navigate(tab.route)}
          className={twMerge(
            "max-w-48 grow cursor-pointer border-b-4 border-transparent px-2 py-4 text-center font-semibold text-zinc-500 hover:bg-zinc-100",
            location.pathname === tab.route && "border-zinc-800 text-zinc-800",
          )}
        >
          <span>{tab.label}</span>
        </div>
      ))}
    </div>
  );
};
